const COOKIE_NAME = "prophero_language";
const COOKIE_DOMAIN = ".prophero.com";
const LS_KEY = "prophero::language";

type Language = "en" | "es";

function isValidLanguage(value: string | null): value is Language {
  return value === "en" || value === "es";
}

export function getStoredLanguage(): Language {
  try {
    if (typeof window === "undefined") throw new Error("Window is undefined");

    const match = document.cookie.match(/(?:^|; )prophero_language=([^;]*)/);
    const cookie = match ? decodeURIComponent(match[1]) : null;
    if (isValidLanguage(cookie)) return cookie;

    const ls = localStorage.getItem(LS_KEY);
    if (isValidLanguage(ls)) return ls;

    throw new Error("No language found");
  } catch {
    return "en";
  }
}

export function storeLanguage(lang: string): void {
  document.cookie = `${COOKIE_NAME}=${lang}; Domain=${COOKIE_DOMAIN}; Path=/; SameSite=Lax; Secure; Max-Age=31536000`;
  try {
    localStorage.setItem(LS_KEY, lang);
  } catch {
    /* blocked */
  }
}
